import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {TaxReportModel, TaxReportSearchParams} from '@accounting/_common/models/tax-report.models';

export const LoadList = createAction(
    '[TaxReports] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[TaxReports] Load List Success',
    props<{ payload: { items: TaxReportModel[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[TaxReports] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetFilter = createAction(
    '[TaxReports] Set Filter',
    props<{ payload: TaxReportSearchParams }>()
);

export const SetLoading = createAction(
    '[TaxReports] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[TaxReports] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[TaxReports] Update Item Success',
    props<{ payload: TaxReportModel }>()
);

export const DeleteItem = createAction(
    '[TaxReports] Delete Item',
    props<{ payload: TaxReportModel }>()
);

export const DeleteItemSuccess = createAction(
    '[TaxReports] Delete Item Success',
    props<{ payload: TaxReportModel }>()
);

export const DeleteItemFailure = createAction(
    '[TaxReports] Delete Item Failure',
    props<{ payload: TaxReportModel }>()
);

export const SetInitialState = createAction(
    '[TaxReports] Set Initial State'
);
